/* eslint-disable @typescript-eslint/no-duplicate-enum-values */
export enum PalantirStatusColorEnum {
  active = '#2FB688',
  approved = '#2FB688',
  archived = '#808080',
  atRisk = '#E2772E',
  available = '#29A37A',
  canceled = '#FF0000',
  completedOnSchedule = '#2FB688',
  completedOutOfSchedule = '#FF0000',
  default = '#888888',
  delivered = '#E59900',
  discarded = '#CC0000',
  done = '#2FB688',
  error = '#FC3868',
  expired = '#FF0000',
  extended = '#FFAA00',
  future = '#00AAFF',
  'in-progress' = '#E2772E',
  inProgress = '#E2772E',
  inactive = '#FF0000',
  installed = '#0055FF',
  new = '#29A37A',
  notApplicable = '#757575',
  'on-route' = '#525F7A',
  onNegotiation = '#FFAA00',
  onSchedule = '#0055FF',
  outOfSchedule = '#FC3868',
  pending = '#6699FF',
  rejected = '#FC3868',
  reported = '#FC3868',
  requested = '#33A1FF',
  scheduled = '#0055FF',
  success = '#2FB688',
  'under-review' = '#FF7733',
}

export type PalantirStatusColor = keyof typeof PalantirStatusColorEnum;
